import React from "react";
import styled from "styled-components";
import Button from "../Button";
import { colors, radius } from "../theme";

const NavBar = ({
  step,
  totalSteps,
  canGoNext,
  isLast,
  loading,
  onBack,
  onNext,
  onSubmit,
  otpState,
}) => {
  const pct = Math.round(((step + 1) / totalSteps) * 100);
  const isFirst = step === 0 && !otpState;

  return (
    <Wrap>
      <ProgressRow>
        <ProgressLabel>
          {isLast ? "Final step" : `Step ${step + 1} of ${totalSteps}`}
        </ProgressLabel>
        <ProgressTrack>
          <ProgressFill $pct={pct} />
        </ProgressTrack>
        <ProgressPct>{pct}%</ProgressPct>
      </ProgressRow>
      <BtnRow>
        <Button
          variant="secondary"
          size="md"
          disabled={isFirst}
          onClick={onBack}
          type="button"
        >
          Back
        </Button>

        {isLast ? (
          <Button
            variant="primary"
            size="lg"
            disabled={!canGoNext || loading}
            loading={loading}
            onClick={onSubmit}
            type="button"
          >
            {loading ? "Processing…" : "Pay & Confirm Booking"}
          </Button>
        ) : (
          <Button variant="primary" size="md" onClick={onNext} type="button">
            Continue
          </Button>
        )}
      </BtnRow>
    </Wrap>
  );
};

export default NavBar;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1.5px solid ${colors.border};
`;

const ProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 360px) {
    display: none;
  }
`;

const ProgressLabel = styled.div`
  font-family: "openSans-SemiBold", sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: ${colors.muted};
  white-space: nowrap;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  min-width: 80px;
`;

const ProgressTrack = styled.div`
  flex: 1;
  height: 5px;
  background: ${colors.border};
  border-radius: ${radius.full};
  overflow: hidden;
`;

const ProgressFill = styled.div`
  height: 100%;
  width: ${(p) => p.$pct}%;
  background: linear-gradient(
    90deg,
    ${colors.teal},
    ${colors.tealLight || "#00a89b"}
  );
  border-radius: ${radius.full};
  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1);
`;

const ProgressPct = styled.div`
  font-family: "openSans-SemiBold", sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: ${colors.teal};
  min-width: 32px;
  text-align: right;
`;

const BtnRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  @media (max-width: 380px) {
    flex-direction: column-reverse;
    gap: 8px;

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;
